module.exports = __webpack_public_path__ + "static/img/9.09bab3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/9.jpg
// module id = qMoh
// module chunks = 1